module.exports = __webpack_public_path__ + "static/img/IMG_0585.25c267e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/dijak-es-ermek/IMG_0585.jpg
// module id = 549
// module chunks = 0